import { useGraphQLQuery } from '@opengov/bnp-core';
import { HASURA_SERVICE_URL } from '../../../../../../config/config';
import { graphql } from '../../../../../../gql-generated/hasura';
import { useToast } from '../../../../Toast/context/useToast.context';
import locale from '../../customReports-locale.json';
import { addReportTableModalQueryKeys } from './addReportTableModalQueryKeys';

const FetchSpreadsheetsForAddReportTableModalQuery = graphql(`
  query GetSpreadsheetsForAddReportTableModal($publicationId: uuid!) {
    spreadsheets(where: { publicationId: { _eq: $publicationId } }) {
      id
      name
    }
  }
`);

export function useFetchSpreadsheetsForAddReportTable({ publicationId }: { publicationId: string }) {
  const { toggleToast } = useToast();
  return useGraphQLQuery({
    queryKey: addReportTableModalQueryKeys.spreadsheets(publicationId),
    variables: { publicationId: publicationId },
    document: FetchSpreadsheetsForAddReportTableModalQuery,
    url: HASURA_SERVICE_URL,
    options: {
      onError: (error) => {
        console.error(error);
        toggleToast({
          title: locale.errors.somethingWentWrong,
          body: locale.errors.unableToFetchSpreadsheets,
          severity: 'error'
        });
      }
    }
  });
}
